<div class="container mt-3">
        <div #termsContent class="terms-content" [innerHTML]="terms"></div>
</div>